/**
 * Site-wide footer rendered on every page (auth + authenticated).
 *
 * Anchored to the bottom of the viewport via the sticky-footer layout
 * established in App.tsx (flex column, body min-height 100vh, routes
 * grow). On short pages the footer sits at the bottom of the viewport;
 * on long pages it sits below the content.
 */
import { BrandLogo } from "./BrandLogo";

export function Footer() {
  return (
    <footer
      className="border-top mt-4 py-3"
      style={{ background: "var(--bs-body-tertiary-bg)" }}
    >
      <div className="container-lg small text-muted d-flex justify-content-center align-items-center gap-2">
        <span>Powered by</span>
        <span className="d-inline-flex align-items-center gap-1">
          {/* size="sm" mark only — the wordmark text "Serviam" lives
              outside the BrandLogo so we can render it bold without
              touching the BrandLogo component (which uses
              "NaaS Manager" as its wordmark). */}
          <BrandLogo size="sm" showWordmark={false} />
          <strong>Serviam</strong>
        </span>
      </div>
    </footer>
  );
}
